import React, { useEffect } from 'react'
import styled from 'styled-components'
import { colors } from '../variables'
import { Container, Row, Col, Visible } from 'react-grid-system'
import {
  SubHeader,
  Ingress,
  Payoff,
  PixelStairsTopLeft,
  PixelStairsContent,
  PageWrapper,
  ImgSet,
} from '../components/Utils'

import { UIStore } from '../stores/UIStore'

import developers from '../img/photos/developers.jpg'
import code from '../img/photos/code.jpg'

const WorkWithUs = () => {
  useEffect(() => {
    UIStore.setBackgroundShade(colors.white)
  }, [])

  return (
    <>
      <LandingArea />
      <Hero />
      <PageWrapper
        style={{
          backgroundColor: colors.green,
        }}
      >
        <Container>
          <DynamicRow style={{ marginTop: 25 }}>
            <Col xs={12} md={6}>
              <SubHeader shade="light">
                Mer än lön – utveckling och entreprenörskap på riktigt
              </SubHeader>
              <Ingress shade="light" style={{ marginTop: 30 }}>
                Vi ser din konsultkarriär som en resa med flera trappsteg.
                <br />
                Du startar som anställd och vi arbetar tillsammans fram en
                gemensam plan efter dina prioriteringar. Flipperspel, tråkiga
                månadsmöten och konferenser finns inte på kartan hos oss på
                Utvecklarbolaget.
                <br />
                Vi jobbar däremot tillsammans för att du efter 3 år kommer kunna
                få ditt eget aktiebolag. Utvecklarbolaget står för kostnaden!
              </Ingress>
              <SubHeader shade="light" style={{ marginTop: 80 }}>
                Mer än lagom – specialisering och expertstöd
              </SubHeader>
              <Ingress
                shade="light"
                style={{ marginTop: 30, marginBottom: 180 }}
              >
                Framtiden bygger vi också här och nu genom att vi förstärker
                vanlig, traditionell specialistförsäljning med CV tillsammans
                med storytelling.
                <strong>
                  Vi jobbar inte bara med vad du gjort utan hur du skapar
                  effekt.
                </strong>
                Vad gör dig unik? Hur omsätter du dina kunskaper till resultat i
                framkant på dina uppdrag? Ny teknik och lösningar och vad dessa
                leder till. Vi kvalitetssäkrar detta med hjälp av en tredjepart
                som validerar specialistnivån så rätt nästa uppdrag matchar dig
                som person, din vardag och din tekniska specialisering och
                intresse.
              </Ingress>
            </Col>
            <Col xs={12} md={6}>
              <div
                style={{ position: 'relative', height: '100%', width: '100%' }}
              >
                <ImgSet
                  img={code}
                  style={{ position: 'absolute', top: -80, left: 40 }}
                />
              </div>
            </Col>
          </DynamicRow>
        </Container>
      </PageWrapper>
    </>
  )
}

export const LandingArea = () => (
  <>
    <LandingHolder>
      <Container>
        <Row>
          <Col xs={12} md={6}>
            <h1 style={{ color: colors.green }}>Vi utvecklar framtiden. Nu.</h1>
          </Col>
          <Col xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
            <Payoff style={{ color: colors.green }}>
              Vi tänker och bygger nytt i en traditionell och snårig bransch så
              alla blir vinnare.
              <br />I kod. I människa. I bolag.
            </Payoff>
          </Col>
        </Row>
      </Container>
    </LandingHolder>
  </>
)

export const Hero = () => (
  <HeroHolder>
    <HeroImg />
    <PixelStairsTopLeft color={colors.green}>
      <div />
      <div />
      <div />
      <div
        style={{
          backgroundColor: colors.green,
          position: 'absolute',
          bottom: '-160px',
          width: '100%',
          height: 160,
        }}
      />
      <Visible xs>
        <div
          style={{
            height: 60,
            bottom: '-200px',
            width: '100%',
            position: 'absolute',
            backgroundColor: colors.green,
          }}
        />
      </Visible>
      <StyledPixelStairsContent style={{ color: colors.green }}>
        <Slide1 style={{ color: colors.white }}>
          <h2>Öppna kort. No bullshit.</h2>
          <Ingress>
            Genom att jobba nära varandra i varje process lever vi som vi lär.
            No bullshit.
          </Ingress>
        </Slide1>
        <Slide2 style={{ color: colors.white }}>
          <h2>Hos oss vinner. Alla.</h2>
          <Ingress>
            Vi ser till att våra samarbeten skapar värde genom hela ledet och
            gör alla till en vinnare; konsulten, näringslivet och även det
            svenska samhället. En så kallad win-win-win.
          </Ingress>
        </Slide2>
      </StyledPixelStairsContent>
    </PixelStairsTopLeft>
  </HeroHolder>
)

const LandingHolder = styled.div`
  height: auto;
  padding: 125px 0 40px;
  box-sizing: border-box;

  h1 {
    margin-bottom: 30px;
  }

  @media (min-width: 769px) {
    padding-top: 200px;
    padding-bottom: 150px;

    h1 {
      margin-bottom: 0;
    }
  }
`

const DynamicRow = styled(Row)`
  flex-direction: column-reverse;

  @media (min-width: 769px) {
    flex-direction: row;
  }

  & > div:first-child {
    margin-top: 240px;

    @media (min-width: 570px) {
      margin-top: 0 !important;
    }
  }
`

const StyledRow = styled(Row)`
  margin-top: 50px;
  margin-bottom: 80px;

  @media (min-width: 769px) {
    margin-top: 370px;
    margin-bottom: 300px;
  }
`

const Slide1 = styled.div`
  margin: -100px 0 0 115px;

  @media (min-width: 769px) {
    margin: 0 60px 0 0;
    width: 380px;
  }
`

const Slide2 = styled.div`
  display: none;

  @media (min-width: 769px) {
    display: inline-block;
    width: 380px;
  }
`

const HeroHolder = styled.section`
  width: 100vw;
  margin: 0 0 100px;
  position: relative;
  padding-bottom: 40px;

  @media (min-width: 769px) {
    padding-bottom: 100px;
  }
`

const HeroImg = styled.div`
  background-image: url(${developers});
  background-size: cover;
  width: 100%;
  height: 280px;

  @media (min-width: 769px) {
    height: 800px;
  }
`

const StyledPixelStairsContent = styled(PixelStairsContent)`
  right: 80px;
  bottom: -110px;

  @media (min-width: 769px) {
    top: auto;
    bottom: 80px;
  }
`

export default WorkWithUs
